import React from "react";
import { Trash2 } from "lucide-react";
import { CAREER_STATUSES } from "@/data/services";
import { EmptyState } from "@/components/admin/AdminBits";

export function CareersPanel({ careers, onStatusChange, onDelete }) {
  if (careers.length === 0) {
    return (
      <div data-testid="careers-panel" className="border border-slate-200 bg-white">
        <EmptyState label="No job applications yet." />
      </div>
    );
  }
  return (
    <div data-testid="careers-panel" className="border border-slate-200 bg-white">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[1000px] text-sm">
          <thead>
            <tr className="text-left text-[10px] uppercase tracking-[0.25em] text-slate-500 border-b border-slate-200">
              <th className="px-4 py-3">Received</th>
              <th className="px-4 py-3">Applicant</th>
              <th className="px-4 py-3">Position</th>
              <th className="px-4 py-3">Contact</th>
              <th className="px-4 py-3">Experience</th>
              <th className="px-4 py-3">Resume</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {careers.map((c) => (
              <tr key={c.id} data-testid={`career-row-${c.id}`} className="border-b border-slate-200 hover:bg-slate-50 align-top">
                <td className="px-4 py-4 text-slate-500 text-xs whitespace-nowrap">
                  {new Date(c.created_at).toLocaleDateString()}<br />
                  {new Date(c.created_at).toLocaleTimeString()}
                </td>
                <td className="px-4 py-4">
                  <div className="font-heading font-bold text-slate-900">{c.full_name}</div>
                  <div className="text-xs text-slate-500">{[c.city, c.state].filter(Boolean).join(", ") || "—"}</div>
                </td>
                <td className="px-4 py-4 text-slate-800 text-xs">
                  <div className="font-bold">{c.position.replace(/_/g, " ")}</div>
                  <div className="text-slate-500">{c.availability.replace(/_/g, " ")}{c.earliest_start ? ` · from ${c.earliest_start}` : ""}</div>
                </td>
                <td className="px-4 py-4 text-xs text-slate-700">
                  <div>{c.email}</div>
                  <div>{c.phone}</div>
                </td>
                <td className="px-4 py-4 text-xs text-slate-700">
                  <div>{c.years_experience || "—"}</div>
                  {c.cdl_class && <div className="text-slate-500">CDL {c.cdl_class}{c.endorsements ? ` · ${c.endorsements}` : ""}</div>}
                  {c.previous_employer && <div className="text-slate-500 truncate max-w-[140px]" title={c.previous_employer}>{c.previous_employer}</div>}
                </td>
                <td className="px-4 py-4 text-xs">
                  {c.resume_url ? (
                    <a href={c.resume_url} target="_blank" rel="noreferrer" className="text-primary-brand hover:underline break-all" data-testid={`career-resume-${c.id}`}>Open link</a>
                  ) : <span className="text-slate-400">—</span>}
                </td>
                <td className="px-4 py-4">
                  <select
                    value={c.status}
                    onChange={(e) => onStatusChange(c.id, e.target.value)}
                    data-testid={`career-status-${c.id}`}
                    className="bg-transparent border border-slate-200 px-2 py-1.5 text-xs uppercase tracking-wider"
                  >
                    {CAREER_STATUSES.map((s) => <option key={s} value={s}>{s.replace(/_/g, " ")}</option>)}
                  </select>
                </td>
                <td className="px-4 py-4 text-right">
                  <button onClick={() => onDelete(c.id)} data-testid={`career-delete-${c.id}`} className="text-slate-500 hover:text-red-500">
                    <Trash2 className="h-4 w-4" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
